import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import ProductCard from '../../molecules/ProductCard/ProductCard';

const ProductGrid = () => {
  const featuredProducts = [
    { id: 1, name: 'Ponni Boiled Rice', brand: 'Chozha', price: 16.66, weight: '10kg', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400', rating: 4.8, reviews: 234, tag: 'Best Seller' },
    { id: 2, name: 'Idli Rice', brand: 'Chozha', price: 17.49, weight: '10kg', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400', rating: 4.9, reviews: 189, tag: 'Premium' },
    { id: 3, name: 'Jeera Samba Rice', brand: 'Chozha', price: 16.65, weight: '5kg', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400', rating: 4.7, reviews: 156, tag: null },
    { id: 4, name: 'Sona Masoori Rice', brand: 'Chozha', price: 17.26, weight: '10kg', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400', rating: 4.6, reviews: 312, tag: 'Popular' },
    { id: 5, name: 'Atta Multigrains', brand: 'Aashirvaad', price: 9.82, weight: '5kg', image: 'https://images.unsplash.com/photo-1627485937980-221c88ac04f9?w=400', rating: 4.5, reviews: 98, tag: null },
    { id: 6, name: 'Tata Salt', brand: 'Tata', price: 1.09, weight: '1kg', image: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400', rating: 4.9, reviews: 567, tag: 'Essential' },
    { id: 7, name: 'Sesame Oil', brand: 'Idhayam', price: 5.85, weight: '1L', image: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400', rating: 4.7, reviews: 145, tag: null },
    { id: 8, name: 'Ponni Boiled Rice', brand: 'Annam', price: 8.37, weight: '5kg', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400', rating: 4.4, reviews: 203, tag: 'Value' },
  ];

  return (
    <section id="shop" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">Best Sellers</span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">Featured Products</h2>
          </motion.div>
          <Link to="/shop">
            <motion.button
              className="flex items-center gap-2 text-primary-600 font-semibold hover:gap-3 transition-all group"
              whileHover={{ x: 5 }}
            >
              View All Products
              <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </motion.button>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ delay: index * 0.1 }}
            >
              <ProductCard product={product} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
